import { env } from '../env/env';
export const userDetailsServiceConfig = {
    USER_DETAILS_SERVICE_URL: env.getString('USER_DETAILS_SERVICE_URL') || 'http://localhost:4001/api/user-details/graphql',
};
//# sourceMappingURL=userDetailsServiceConfig.js.map